import { experimentEnabled } from '../../../adapters/experimentEnabled';
export var shouldRenderPanelSchema = function (tag, context) {
    if (context === void 0) { context = {}; }
    var _a = tag.meta || {}, enabledByExperiment = _a.enabledByExperiment, _b = _a.removeSchemaIfEmpty, removeSchemaIfEmpty = _b === void 0 ? [] : _b;
    var isEnabledBySpec = !enabledByExperiment || experimentEnabled(enabledByExperiment, context);
    var isMissingData = removeSchemaIfEmpty.some(function (variable) { return !context[variable]; });
    return isEnabledBySpec && !isMissingData;
};
